import {
  StatisticApi, Statistics, // eslint-disable-line no-unused-vars
} from '@clients/bff'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { toEndOfDayIsoString, toStartOfDayIsoString } from '@util/dates-and-times'

let basePath = getBasePath()

export default class ExtendedStatisticApi extends StatisticApi {
  getStatistics (filterFrom: string, filterUntil: string, vehicleId?: number, smartConnectInfo?: boolean, options?: any): AxiosPromise<Statistics> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getStatistics(toStartOfDayIsoString(filterFrom), toEndOfDayIsoString(filterUntil), vehicleId, smartConnectInfo, optionsParam)
  }
}
